import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	success: {
		id: 'paymentElementsForm.formMessages.success',
		defaultMessage: 'Your payment was successful',
		description: 'Form message for successful purchase',
	},
	processing: {
		id: 'paymentElementsForm.formMessages.processing',
		defaultMessage: 'Your payment is processing.',
		description: 'Form message for purchase that is still processing',
	},
	unsuccessful: {
		id: 'paymentElementsForm.formMessages.unsuccessful',
		defaultMessage: 'Your payment was not successful, please try again.',
		description: 'Form message for unsuccessful purchase',
	},
	fallback: {
		id: 'paymentElementsForm.formMessages.fallback',
		defaultMessage: 'Something went wrong.',
		description: 'Fallback form message for a failed purchase',
	},
	or: {
		id: 'paymentElementsForm.options.or',
		defaultMessage: 'Or',
		description: 'The word "Or" distinguishing payment options',
	},
	applePayPaymentDescription: {
		id: 'paymentElementsForm.applePay.paymentDescription',
		defaultMessage:
			'You will not be charged today. "Amount pending" will apply only if you keep your Calm subscription after the free trial',
		description: 'An explanation for the "Amount pending" text when paying with Apple Pay',
	},
	// Stripe's Clover change (2025-09-30) stops the deferred Payment Element from
	// auto-collecting the postal code for CA / UK / PR; we collect it ourselves there.
	postalCodeRequired: {
		id: 'paymentElementsForm.postalCode.required',
		defaultMessage: 'Please enter your postal code to continue.',
		description: 'Error shown when the card payment is submitted before a required postal code is entered',
	},
	// Puerto Rico variant — keeps the required-error wording in sync with the locale-aware
	// label below ("ZIP code" for PR), selected via the same `usesZipCodeLabel` predicate.
	postalCodeRequiredPR: {
		id: 'paymentElementsForm.postalCode.requiredPR',
		defaultMessage: 'Please enter your ZIP code to continue.',
		description:
			'Error shown when the card payment is submitted before a required ZIP code is entered (Puerto Rico)',
	},
	// Matches Stripe's own labeling: "Postal code" for CA and UK (GB), "ZIP code" only
	// for Puerto Rico.
	postalCodeLabel: {
		id: 'paymentElementsForm.postalCode.label',
		defaultMessage: 'Postal code',
		description: 'Label for the custom postal code input shown for Canadian and UK billing addresses',
	},
	postalCodeLabelPR: {
		id: 'paymentElementsForm.postalCode.labelPR',
		defaultMessage: 'ZIP code',
		description: 'Label for the custom postal code input shown for Puerto Rico billing addresses',
	},
});
